import * as resolvers from 'app/infrastructure/ui/renderer/resolvers';
import { CaseState } from 'app/area/case/types-store';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';

export interface FieldValuesMappings {  
  /**
   * The name to use for the field
   */
  fieldName : string;

  /**
   * Only select rows where this column has a value. 
   * If not defined, count all entities in the target table
   */
  dataTag: string;
}

export const fieldValues = (propMappings : FieldValuesMappings[]) => 
                                    (caseState: CaseState, uiEngineProps: ConnectedComponentProps) => {  
    const fieldObject = {};

    propMappings.forEach((p) => {      
      const componentValues =  resolvers.getComponentValues(caseState, uiEngineProps, p.dataTag);
      fieldObject[p.fieldName] = {valueObject: componentValues, propName: p.fieldName};      
    });    

    return fieldObject;
};
